import { createContext, PropsWithChildren, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { showErrorNotification } from '../../components/shared/notifications';
import { getImpersonation } from '@/utils/impersonation';

type UploadAssetsValue = {
  open: () => void;
  close: () => void;
  opened: boolean;
};

const UploadAssetsContext = createContext<UploadAssetsValue>({
  open: () => {},
  close: () => {},
  opened: false,
});

export const UploadAssetsProvider = ({ children }: PropsWithChildren) => {
  const [opened, { open, close }] = useDisclosure(false);
  const onOpen = () => {
    const { isImpersonating } = getImpersonation();
    if (isImpersonating) {
      showErrorNotification({
        title: 'You cannot upload when impersonating another user',
        message: 'Please stop impersonating the user to upload assets',
      });
      return;
    }
    open();
  };

  return (
    <UploadAssetsContext.Provider value={{ open: onOpen, close, opened }}>{children}</UploadAssetsContext.Provider>
  );
};

export const useUploadAssets = () => {
  return useContext(UploadAssetsContext);
};
